import { ItemCategory } from '../interfaces/item-category.interface';

/** Display name: "Parent › Sub" for a sub-category, the plain name for a main category. */
export const categoryLabel = (c: { itemCategoryName: string; fullName?: string | null }): string =>
    c.fullName || c.itemCategoryName;

/** Main categories A-Z, each followed by its own sub-categories A-Z (subs whose parent is missing go last). */
export function sortCategoryTree(categories: ItemCategory[]): ItemCategory[] {
    const byName = (a: ItemCategory, b: ItemCategory) => a.itemCategoryName.localeCompare(b.itemCategoryName);
    const tops = categories.filter(c => !c.parentId).sort(byName);
    const out: ItemCategory[] = [];
    tops.forEach(top => {
        out.push(top);
        out.push(...categories.filter(c => c.parentId === top.id).sort(byName));
    });
    out.push(...categories.filter(c => !out.includes(c)));
    return out;
}
